module.exports = __webpack_public_path__ + "media/video3.d7f9735c.mp4";